function service ($http, listingService, $q) {

    const customerEndPoint = '/ajax/customersapi/1.0/customer/detail/';

    return {
        getSeller
    };

    function getSeller() {
        return listingService.getListing().then((listing)=> {
            if (!listing.listingDetailDto.privatePartyListing) {
                let sellerId = listing.listingDetailDto.sellerId;

                return $http.get(customerEndPoint + sellerId, {cache: true});
            } else {
                return $q.reject('Seller is private party.');
            }
        });
    }
}

service.$inject = [
    '$http',
    'listingService',
    '$q'
];

export default service;